"use strict";
module.exports = function createDate(yr, mo, day) {
    return new Date(yr, mo, day, 0, 0);
};
